module.exports = __webpack_public_path__ + "fef388a5de039f96fb2877992ec5a97d.svg";